module.exports = __webpack_public_path__ + "img/首页_enterprise.d13c5272.svg";